import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import * as Icons from "lucide-react";
import { SERVICES } from "../../lib/site-data";

export default function ServicesGrid({ limit }) {
    const items = limit ? SERVICES.slice(0, limit) : SERVICES;
    return (
        <section className="relative py-24 md:py-32 border-b border-white/5" data-testid="services-section">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12 md:mb-16">
                    <div>
                        <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-3">
                            Hizmetlerimiz
                        </p>
                        <h2 className="font-display text-3xl md:text-5xl text-white tracking-tight max-w-2xl text-balance">
                            Pico lazer ve Fraksiyonel CO2 lazer uygulamaları
                        </h2>
                    </div>
                    <p className="text-sm text-zinc-400 max-w-md">
                        Her dövme ve iz farklıdır. Aşağıdaki uygulamalar için kişisel ön
                        değerlendirme planlanır.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                    {items.map((s) => {
                        const Icon = Icons[s.icon] || Icons.Sparkles;
                        return (
                            <Link
                                key={s.slug}
                                to={`/${s.slug}`}
                                className="group relative bg-[#0E0E0E] border border-white/5 rounded-2xl p-7 hover:border-cyan-400/40 hover:-translate-y-1 transition-all duration-300 overflow-hidden"
                                data-testid={`service-card-${s.slug}`}
                            >
                                <div className="absolute -top-12 -right-12 w-40 h-40 bg-cyan-400/10 blur-[60px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></div>
                                <div className="relative flex items-start justify-between mb-8">
                                    <div className="w-11 h-11 rounded-xl bg-cyan-400/10 border border-cyan-400/20 flex items-center justify-center text-cyan-300">
                                        <Icon className="h-5 w-5" strokeWidth={1.5} />
                                    </div>
                                    <ArrowUpRight className="h-5 w-5 text-zinc-600 group-hover:text-cyan-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                                </div>
                                <h3 className="font-display text-xl text-white mb-2 tracking-tight">
                                    {s.title}
                                </h3>
                                <p className="text-sm text-zinc-400 leading-relaxed">
                                    {s.short}
                                </p>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
